<template>
  <v-app>
    <nav-draw v-if="getLoggedIn" v-model="drawer"></nav-draw>

    <v-app-bar v-if="!loadingapp" :class="primaryBg" app dark>
      <v-app-bar-nav-icon @click="drawer=!drawer" v-if="getLoggedIn && getLoggedInUser.isadmin"></v-app-bar-nav-icon>

      <v-img max-width="113" max-height="46" aspect-ratio="1" src="img/logo.svg" @click="home()"></v-img>
      <v-divider class="mx-4" inset vertical></v-divider>
      <v-toolbar-title class="headline">
        <span class="text-uppercase">{{ $t("common.app.name") }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu
        v-if="getLoggedIn"
        open-on-hover
        bottom
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on">
            <v-icon left>translate</v-icon>
            <span class="mr-2">{{ getUserLanguage }}</span>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="item in getLanguages"
            :key="item.lang"
            @click="changeLanguage(item.lang)"
          >
            <v-list-item-title>{{ item.name }}</v-list-item-title>
            <v-list-item-icon v-if="item.lang == getLoggedInUser.lang">
              <v-icon>done</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn text v-if="getLoggedIn" @click="logout">
        <v-icon left>logout</v-icon>
        <span class="mr-2">{{ $t("common.logout") }}</span>
      </v-btn>
    </v-app-bar>

    <v-main v-if="!loadingapp" :class="randomBackground()">
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-snackbar v-model="showErrorSnackbar" top color="error" :timeout="5000">
      {{ getErrorMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="showErrorSnackbar = false">{{ $t('common.close') }}</v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="showInfoSnackbar" top color="info" :timeout="5000">
      {{ getInfoMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="showInfoSnackbar = false">{{ $t('common.close') }}</v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="showWarningSnackbar" top color="warning" :timeout="5000">
      {{ warningMessageText }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="openAlarms">{{ $t('alarm.show') }}</v-btn>
        <v-btn dark text v-bind="attrs" @click="showWarningSnackbar = false">{{ $t('common.close') }}</v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="getLongLoader.show" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="loadingtext">
          {{ getLongLoaderMessage }}
          <v-progress-linear indeterminate color="white" height="5" class="mt-1 mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div class="loadingdiv" v-if="loadingapp">
      <v-layout row justify-center>
        <v-dialog
          v-model="loadingapp"
          hide-overlay
          persistent
          content
          content-class="centered-dialog"
        >
          <v-container fill-height>
            <v-layout column justify-center align-center>
              <h1 class="pb-3">Tone Generator Loading</h1>
              <v-progress-circular indeterminate :size="50" :width="7" color="primary"></v-progress-circular>
              <h3 class="pt-3">Please wait...</h3>
            </v-layout>
          </v-container>
        </v-dialog>
      </v-layout>
    </div>
  </v-app>
</template>

<script>
import Vue from "vue"
import { mapActions, mapGetters, mapMutations } from "vuex";
import NavDraw from "./components/NavDraw.vue";

export default {
  name: "tonegen",
  components: {
    "nav-draw": NavDraw
  },
  data() {
    return {
      showErrorSnackbar: false,
      showInfoSnackbar: false,
      showWarningSnackbar: false,
      drawer: false
    };
  },
  computed: {
    ...mapGetters([
      "getLoadingApp",
      "getLoggedIn",
      "getLoggedInUser",
      "getErrorMessage",
      "getInfoMessage",
      "getWarningMessage",
      "getWarningDevice",
      "getLongLoader",
      "getLongLoaderMessage",
      "getLanguages"
    ]),
    primaryBg() {
      if (!this.getLoggedIn) return null;
      return "primary";
    },
    loadingapp() {
      return this.getLoadingApp;
    },
    getUserLanguage() {
      let lang = this.getLanguages.filter(l => l.lang == this.getLoggedInUser.lang)
      if (lang.length == 1)
        return lang[0].name
      return ""
    },
    warningMessageText() {
      if (this.getWarningMessage) {
        return this.getWarningMessage.txt ? this.getWarningMessage.txt : (this.getWarningDevice + ": " + this.$i18n.t("alarm.at" + this.getWarningMessage.at) )
      }
      return ""
    }
  },
  watch: {
    getErrorMessage() {
      this.showErrorSnackbar = this.getErrorMessage !== "";
    },
    getInfoMessage() {
      this.showInfoSnackbar = this.getInfoMessage !== "";
    },
    getWarningMessage() {
      this.showWarningSnackbar = this.getWarningMessage !== "";
    },
    getLoggedIn(value) {
      if (!value) this.$router.push({ name: "login" });
    }
  },
  methods: {
    ...mapActions(["doLogout","doUpdateUserLanguage","doGetDevice"]),
    ...mapMutations(["mShowLongLoader", "mHideLongLoader"]),
    logout() {
      if (this.getLoggedInUser.openidauth) location.href = Vue.$href("logout");
      else this.doLogout();
    },
    async changeLanguage(lang) {
      Vue.$log.debug("Updating user language to: ", lang)
      await this.doUpdateUserLanguage({userid: this.getLoggedInUser.id, lang})
    },
    randomBackground() {
      if (this.$TARGET === "development") console.log("Development build");
      if (this.$TARGET === "production") console.log("Production build");

      if (this.getLoggedIn) return null;
      let imgid = Math.floor(Math.random() * 8) + 10;
      return `tonegeneratorpagebg${imgid}`;
    },
    home() {
      this.$router.push({ name: "home" })
    },
    async openAlarms() {
      this.showWarningSnackbar = false
      this.mShowLongLoader(this.$i18n.t("common.pleasewait"))
      await this.doGetDevice(this.getWarningDevice)
      this.mHideLongLoader()
      this.$router.push({ name: "device", params: { id: this.getWarningDevice, openAlarms: true } })
    }
  },
};
</script>

<style>
.loadingdiv {
  height: 100vh;
  width: 100vw;
  background: #e7e8ea;
}

.bgimg {
  background-image: url("/img/loginbg.jpg");
  background-size: cover;
}

.dialog.centered-dialog,
.v-dialog.centered-dialog {
  background: white;
  box-shadow: none;
  border-radius: 6px;
  width: auto;
  color: #556689;
  border: 3px solid #556689;
}

.whitecontainer {
  background-color: white;
}
.toprightdiv {
  position: absolute !important;
  top: 15px !important;
  right: 15px !important;
}
.topleftdiv {
  position: absolute !important;
  top: 0px !important;
  left: 0px !important;
}
.bottomleftdiv {
  position: absolute !important;
  bottom: 0px !important;
  left: 0px !important;
}
.silentlink {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}
.silentlink:hover {
  color: #000;
  text-decoration: underline;
}
.v-table__overflow {
  overflow-x: hidden;
}
.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0px;
}

.topleftcorner {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
}
.toprightcorner {
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
}

.text-h5 {
  padding-left: 5px;
}
.v-btn {
  font-weight: 400;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 13px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 13px;
}

.v-main__wrap > div {
  height: 95%;
}
.fullh {
  height: 100%;
}
.nfullh {
  height: 90%;
}

.context {
  padding-left: 0px !important;
}

.loadingtext {
  font-size: 16px;
}

.tonegeneratorpagebg10 {
  background-image: url("/bg/10.jpg");
  background-size: cover;
}
.tonegeneratorpagebg11 {
  background-image: url("/bg/11.jpg");
  background-size: cover;
}
.tonegeneratorpagebg12 {
  background-image: url("/bg/12.jpg");
  background-size: cover;
}
.tonegeneratorpagebg13 {
  background-image: url("/bg/13.jpg");
  background-size: cover;
}
.tonegeneratorpagebg14 {
  background-image: url("/bg/14.jpg");
  background-size: cover;
}
.tonegeneratorpagebg15 {
  background-image: url("/bg/15.jpg");
  background-size: cover;
}
.tonegeneratorpagebg16 {
  background-image: url("/bg/16.jpg");
  background-size: cover;
}
.tonegeneratorpagebg17 {
  background-image: url("/bg/17.jpg");
  background-size: cover;
}
</style>
